import { Card, Typography, Link } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';

/**
 * Arrears card
 * @param {*} param0
 * @returns
 */

function DefaultCard({
    id,
    backgroundColor,
    textColor,
    tel
}) {
    return (
        <Card
            id={id}
            sx={{
                backgroundColor: `${backgroundColor}`,
                color: `${textColor}`,
                borderRadius: 0,
            }}
        >
            <span
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: "bold",
                        fontSize: 20,
                        ml: 2,
                        pt: 1.2,
                        flexGrow: 1,
                    }}
                >
                    Your account is defaulted <CircleIcon sx={{ color: "#EA4278", fontSize: "18px", verticalAlign: "top" }} />
                </Typography>
            </span>
            <Typography
                sx={{
                    fontSize: 16,
                    mt: 1.5,
                    mx: 2,
                }}
            >
                We have issued a notice of default in the post, which confirms that as you've missed more than 3 of your agreed, contractual repayments - your account has now defaulted.
                For help with this, please call the team on <Link sx={{color: "secondary.main"}} href={`tel:${tel}`}>{tel}</Link>.
            </Typography>
            <Typography
                sx={{
                    fontSize: 16,
                    mt: 1.5,
                    mx: 2,
                    mb: 2
                }}
            >
                The default will be registered with the Credit Referencing Agencies, which will impact your ability to borrow money in the future. The outstanding balance on the account is listed above. Please get in touch so that we can support you to repay this in an affordable way.
            </Typography>
        </Card>)
}


export default DefaultCard;